"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Deferred = void 0;
/**
 * Promise holder.
 */
class Deferred {
    constructor() {
        this._resolve = () => { };
        this._reject = () => { };
        /**
         * Resolves the stored promise.
         */
        this.resolve = (value) => {
            this._resolve(value);
        };
        /**
         * Rejects the stored promise.
         */
        this.reject = (reason) => {
            this._reject(reason);
        };
        this._promise = new Promise((resolve, reject) => {
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    /**
     * Stored promise.
     */
    get promise() {
        return this._promise;
    }
}
exports.Deferred = Deferred;
//# sourceMappingURL=deferred.js.map